import { makeStyles } from "@material-ui/core/styles";
import Flex from "components/grid/Flex";
import { useTranslation } from "react-i18next";
import { isAnyPresent, makeHistory } from "../../HistoryUtils";
import HistoryContainerAndTitle from "./HistoryContainerAndTitle";
import ConditionalLabelAndValue from "./ConditionalLabelAndValue";
import SimpleArrayOfValues from "./SimpleArrayOfValues";
import DateAndValueArrayContainer from "./DateAndValueArrayContainer";

const useStyles = makeStyles((theme) => ({}));

const HematologyHistory = ({ anamnesisHistory }) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const history = makeHistory(anamnesisHistory);
    const hematoDiseases = [
        ...history.getLatestSubDataRows("haveActiveHematoDiseaseData"),
        ...history.getLatestSubDataRows("haveFormerHematoDiseaseData"),
    ];
    const bloodCountData = [
        ...history.getLatestSubDataRows("haveCurrentChangeInBloodCountData"),
        ...history.getLatestSubDataRows("havePreviousChangeInBloodCountData"),
    ];
    const isVisible = isAnyPresent(anamnesisHistory, [
        "haveActiveHematoDiseaseData",
        "haveFormerHematoDiseaseData",
        "haveCurrentChangeInBloodCountData",
        "havePreviousChangeInBloodCountData",
        "haveBoneMarrowPuncturedData",
        "haveHematoFamilialSyndromOrGeneticText",
        "haveAbdomenUltrasoundData",
        "haveHematoFamilialSyndromOrGenetic",
        "haveActiveHematoDisease",
        "haveFormerHematoDisease",
        "haveAbdomenUltrasound",
        "haveCurrentChangeInBloodCount",
        "havePreviousChangeInBloodCount",
    ]);
    return (
        <HistoryContainerAndTitle title={t(`anamnesis.hematology.title`)} isVisible={isVisible}>
            <Flex item grow={0} container column style={{ margin: "5px 0px" }}>
                <SimpleArrayOfValues
                    {...{
                        label: `${t("anamnesis.hematology.boneMarrowPunctured")}:`,
                        array: history.getLatestSubDataRows("haveBoneMarrowPuncturedData"),
                        translationKey: "anamnesis.hematology",
                        questionsToTranslate: ["cellularity", "fibrosis"],
                    }}
                />

                <ConditionalLabelAndValue
                    {...{
                        switchValue: history.getLatestValueOf("haveHematoFamilialSyndromOrGenetic"),
                        value: history.getLatestValueOf("haveHematoFamilialSyndromOrGeneticText"),
                        label: `${t("anamnesis.hematology.haveHematoFamilialSyndromOrGenetic")}`,
                    }}
                />
                <DateAndValueArrayContainer
                    yearOnly
                    {...{
                        switchValue: history.getLatestValueOf("haveActiveHematoDisease") || history.getLatestValueOf("haveFormerHematoDisease"),
                        array: hematoDiseases,
                        label: `Z.n. ${t("anamnesis.hematology.hematoDisease")}:`,
                    }}
                />
                <DateAndValueArrayContainer
                    yearOnly
                    {...{
                        switchValue: history.getLatestValueOf("haveAbdomenUltrasound"),
                        array: history.getLatestSubDataRows("haveAbdomenUltrasoundData"),
                        label: `${t("anamnesis.hematology.abdomenUltrasound")}:`,
                    }}
                />
                <DateAndValueArrayContainer
                    yearOnly
                    {...{
                        switchValue: history.getLatestValueOf("haveCurrentChangeInBloodCount") || history.getLatestValueOf("havePreviousChangeInBloodCount"),
                        array: bloodCountData,
                        label: `Z.n. ${t("anamnesis.hematology.changeInBloodCount")}:`,
                        translationKey: "anamnesis.hematology",
                    }}
                />
            </Flex>
        </HistoryContainerAndTitle>
    );
};

export default HematologyHistory;
